import { render } from "./UserProfile.vue?vue&type=template&id=daca21fe&scoped=true"
import script from "./UserProfile.vue?vue&type=script&lang=js"
export * from "./UserProfile.vue?vue&type=script&lang=js"

import "./UserProfile.vue?vue&type=style&index=0&id=daca21fe&scoped=true&lang=css"

import exportComponent from "/Users/matalem/system/radioaconcagua/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-daca21fe"]])

export default __exports__